import * as Sentry from "@sentry/react";

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;

const isSentryEnabled =
  Boolean(sentryDsn) && Boolean(import.meta.env.VITE_SENTRY_RELEASE);

export const sentryConfig = {
  dsn: sentryDsn,
  environment: "production",
  release: import.meta.env.VITE_SENTRY_RELEASE
    ? `ordering-ai-dashboard@${import.meta.env.VITE_SENTRY_RELEASE}`
    : undefined,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.1,
  enabled: isSentryEnabled,
};

export const initSentry = () => {
  if (!isSentryEnabled) {
    return false;
  }
  try {
    Sentry.init(sentryConfig);
    return true;
  } catch {
    return false;
  }
};

// Helper functions for manual error reporting
export const captureException = (error, context = {}) => {
  if (!isSentryEnabled) {
    return;
  }
  Sentry.withScope((scope) => {
    Object.keys(context).forEach((key) => {
      scope.setContext(key, context[key]);
    });
    Sentry.captureException(error);
  });
};

export const captureMessage = (message, level = "info", context = {}) => {
  if (!isSentryEnabled) {
    return;
  }
  Sentry.withScope((scope) => {
    Object.keys(context).forEach((key) => {
      scope.setContext(key, context[key]);
    });
    Sentry.captureMessage(message, level);
  });
};

export const addBreadcrumb = (breadcrumb) => {
  if (!isSentryEnabled) {
    return;
  }
  Sentry.addBreadcrumb(breadcrumb);
};

export const setUser = (user) => {
  if (!isSentryEnabled) {
    return;
  }
  Sentry.setUser(user);
};

export const setTag = (key, value) => {
  if (!isSentryEnabled) {
    return;
  }
  Sentry.setTag(key, value);
};

export const setContext = (key, context) => {
  if (!isSentryEnabled) {
    return;
  }
  Sentry.setContext(key, context);
};
